import { Stack, Typography } from '@mui/material'

interface OutcomeRowProps {
  label: string
  value: string
}

export function OutcomeRow({ label, value }: OutcomeRowProps) {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="body2">{label}</Typography>
      <Typography variant="subtitle2">{value}</Typography>
    </Stack>
  )
}
